import ReactLoader from './react_loader'

ReactLoader.registerComponents({
  Cut: require('../components/CutToSize/Cut'),
  CutMaker: require('../components/CutToSize/CutMaker'),
  Tube: require('../components/CutToSize/Tube')
})
